import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=58ca24c0&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=58ca24c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ca24c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58ca24c0')) {
      api.createRecord('58ca24c0', component.options)
    } else {
      api.reload('58ca24c0', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=58ca24c0&scoped=true&", function () {
      api.rerender('58ca24c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2v3U4B2qSjxGw/JS/teamMember.vue"
export default component.exports